<template>
  <div class="container-fluid py-4">
    <h4 class="h4 font-weight-bold text-left text-capitalize">
      Room Actual Utilization
    </h4>
    <hr />
    <div class="row mb-3">
      <div class="col-sm-6 d-flex align-items-center">
        <h5 class="h5 font-weight-bold text-left text-capitalize mb-0 mt-1">
          {{hotelName.name}}
        </h5>
      </div>
      <div class="col-sm-6">
        <select class="form-control form-control-sm w-auto float-right m-0" v-model="formParam.hotelId" v-on:change="getData">
          <option v-for="(hotel,index) in actualizationHotels" :key="index" :value="hotel.id" :selected="true">{{titleCase(hotel.name)}}</option>
        </select>

        <select class="form-control form-control-sm w-auto float-right my-0 mx-3" v-model="formParam.monthId" v-on:change="getData">
          <option v-for = "monthName in monthNames" :value="monthName.id" :key="monthName.id">
            {{titleCase(monthName.name)}}
          </option>
        </select>
      </div>
    </div>

    <div class="table table-responsive" style="height: 700px !important;  overflow: auto;">
      <table class="table table-striped table-sm table-bordered sticky-header">
        <thead v-if="actualizationHeader.length != 0">
        <tr>
          <th scope="col">Date</th>
          <th scope="col" v-for="(floor,index) in actualizationHeader" :key="index">
            {{titleCase(floor.name)}}
          </th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="(dates,index) in actualizationData" :key="index">
          <th scope="row" width="150">{{dates.date}}</th>
          <td scope="row" v-for="(dates,index) in dates[index]" :key="index">{{dates.bedsOccupiedOnFloor}} / {{dates.bedsOnFloor}}</td>
          <td scope="row" >{{dates.totalBedsOccupiedOnFloor}} / {{dates.totalBedsOnFloor}}</td>
          <td scope="row" >{{dates.totalPercentage}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {appMixins} from '@/mixins/app.mixins';

export default {
  name: "ActualUtilization",
  mixins : [appMixins],
  data (){
    return {
      selectedMonth: 0,
      monthNames: [
          {id: 1, name:'January'},
          {id: 2, name:'February'},
          {id: 3, name:'March'},
          {id: 4, name:'April'},
          {id: 5, name:'May'},
          {id: 6, name:'June'},
          {id: 7, name:'July'},
          {id: 8, name:'August'},
          {id: 9, name:'September'},
          {id: 10, name:'October'},
          {id: 11, name:'November'},
          {id: 12, name:'December'},
      ],

      formParam : {
        hotelId : 1,
        monthId : 1,
      },
    }
  },
  methods: {
    ...mapActions([
        'getActualUtilization',
        'setActualizationNull',
        'setActualizationHotelsNull',
    ]),

    getDaysInMonth(month, year) {
      // let monthIndex = month - 1;
      let date = new Date(year, month, 1);
      let days = [];
      while (date.getMonth() === month) {
        days.push(date.getDate());
        date.setDate(date.getDate() + 1);
      }
      return this.days = days;
    },
    pickedMonth(){
      this.getDaysInMonth(this.selectedMonth,2020);
    },

    async getData(){
      await this.getActualUtilization( this.formParam);
    }



  },

  computed : {
    ...mapGetters([
        'actualizationHeader',
        'actualizationData',
        'actualizationHotels'
    ]),


    hotelName : {
      get(){
        return this.actualizationHotels.find((value => value.id === this.formParam.hotelId));
      },

      set(val){
        this.formParam.hotelId;
      }
    }

  },

 async created() {
    this.getData();
    this.getDaysInMonth(this.selectedMonth,2020);
  },

  destroyed() {
    // this.setActualizationNull();
    this.setActualizationHotelsNull();
  }
}
</script>

<style scoped>
.sticky-header > thead > tr > th {
  background-color: #dee2e6 !important;
  position: sticky !important;
  z-index: 100;
  top: 0;
}
</style>
